export default "__VITE_ASSET__b975e881__"